import LegalPage from '@/components/legal/LegalPage';

export default function ResponsibleLending() {
  return (
    <LegalPage
      title="Responsible Lending Policy"
      intro="Our commitment to lending only where borrowing is affordable and appropriate."
      sections={[
        {
          heading: 'Our commitment',
          body: (
            <p>
              Quick Credit lends responsibly. We assess every application on its merits and only approve a
              loan where we reasonably believe the repayments are affordable and sustainable for you. We do
              not offer guaranteed approval, and we will decline applications where borrowing is not in your
              interest.
            </p>
          ),
        },
        {
          heading: 'Affordability assessment',
          body: (
            <p>
              We review your income, regular outgoings, existing credit commitments and credit history. We
              may ask for supporting documents such as pay stubs or bank statements to verify what you have
              told us.
            </p>
          ),
        },
        {
          heading: 'Clear, honest information',
          body: (
            <p>
              Before you sign, we disclose the loan amount, fixed APR, term, monthly payment, total amount
              repayable and all applicable fees. We never use pressure selling and we never advertise
              approval outcomes we cannot deliver.
            </p>
          ),
        },
        {
          heading: 'If you are struggling to repay',
          body: (
            <p>
              Contact us as early as possible. We can discuss options such as changing your payment date,
              a temporary payment arrangement, or a revised plan. We treat customers in financial
              difficulty fairly and will not add pressure to a difficult situation.
            </p>
          ),
        },
        {
          heading: 'Free debt advice',
          body: (
            <p>
              Free, impartial debt advice is available from non-profit organisations such as the National
              Foundation for Credit Counseling (nfcc.org). Using a free advice service will never affect
              how we treat your account.
            </p>
          ),
        },
        {
          heading: 'Borrow carefully',
          body: <p>Late or missed payments may result in fees, additional interest and damage to your credit rating. Borrow only what you need and can comfortably repay.</p>,
        },
      ]}
    />
  );
}
